import { useEffect, useState } from "react";
import {
  Container,
  Content,
  SubTitle,
  Title,
  Text,
  BoxStyled,
  InputStyled,
  TextNumber,
  CardStyled,
  CellContent,
  CellTitle,
  CellDivider,
  Row,
  HeaderModal,
  ContainerGrid,
  ContainerForm,
} from "./style";
import {
  Box,
  Button,
  Card,
  Divider,
  Modal,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  FormHelperText,
  TextareaAutosize,
  Grid,
  Typography,
  Stack,
  Chip,
} from "@mui/material";
import { Close, InsertDriveFile } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import { Header } from "../Header";
import ProgressCircle from "../../ui/ProgressCircle";
import { colorsProgress } from "../../data/colorsProgress";
import { useParams } from "react-router-dom";
import { getSessionUser } from "../../utils/users";
import { IUser } from "../Login/ILogin";
import { Empresas } from "../../utils/empresa";
import { apiOperation, headers } from "../../services/api";
import {
  RetornoAnalise,
  Resultado,
  AnaliseDemonstrativo,
} from "../../models/retornoAnalise";
import { TipoIndiceFinanceiro } from "../../models/enums/TipoIndiceFinanceiroEnum";
import { cnpjMask, cpfMask } from "../../utils/mask";
import { Loading } from "../Loading";
import { TipoVariavelFinanceira } from "../../models/enums/TipoVariavelFinanceiraEnum";
import { TipoPorte } from "../../models/enums/TipoPorteEnum";
import {
  TableDocuments,
  TableIndebtedness,
  TableLiquidity,
  TablePartners,
  TableProfitability,
} from "./Tables";
import { Documento } from "../../models/analise";
import { ContainerTextArea } from "../newSearch/style";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

const r: Resultado = {};

let usuarioLogado: IUser | null = null;

interface FormData {
  codigoEmpresa: string;
  valorLimite: string;
  tipoLimite: string;
  valorFaturado?: string;
  valorCartao?: string;
  parecerComercial?: string;
}

export const Results = () => {
  const { id } = useParams();
  const [result, setResult] = useState<Resultado>(r);
  const [showLoading, setShowLoading] = useState(false);
  const [carregaItens, setCarregaItens] = useState(false);
  const [showDetaisIndicators, setShowDetaisIndicators] = useState({
    liquidity: true,
    indebtedness: true,
    profitability: true,
  });
  const [modalState, setModalState] = useState({
    open: false,
    title: "",
    children: <></>,
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    codigoEmpresa: "",
    valorLimite: "",
    tipoLimite: "FAT",
    valorFaturado: "",
    valorCartao: "",
    parecerComercial: "",
  });
  const [errors, setErrors] = useState<Partial<FormData>>({});

  const viewDetaisIndicators = (demonstrativo: AnaliseDemonstrativo[]) => {
    if (demonstrativo.length > 0) {
      const countLiq = demonstrativo.filter(
        (item: AnaliseDemonstrativo) =>
          item.tipoVariavelFinanceira === TipoIndiceFinanceiro.LiquidezCorrente,
      );
      const countIndeb = demonstrativo.filter(
        (item: AnaliseDemonstrativo) =>
          item.tipoVariavelFinanceira ===
            TipoIndiceFinanceiro.DividaBancariaEbitda ||
          item.tipoVariavelFinanceira ===
            TipoIndiceFinanceiro.EndividamentoGeral ||
          item.tipoVariavelFinanceira ===
            TipoIndiceFinanceiro.CoberturaDaDivida ||
          item.tipoVariavelFinanceira === TipoIndiceFinanceiro.CaixaBancosCP,
      );

      const countProfit = demonstrativo.filter(
        (item: AnaliseDemonstrativo) =>
          item.tipoVariavelFinanceira === TipoIndiceFinanceiro.ROIC,
      );
      setShowDetaisIndicators({
        liquidity: countLiq.length > 0,
        indebtedness: countIndeb.length > 0,
        profitability: countProfit.length > 0,
      });
    } else {
      setShowDetaisIndicators({
        liquidity: false,
        indebtedness: false,
        profitability: false,
      });
    }
  };

  useEffect(() => {
    usuarioLogado = getSessionUser();
    if (
      usuarioLogado?.empresa === Empresas.BRT &&
      usuarioLogado.perfil !== "Agencia-brt"
    ) {
      setCarregaItens(true);
    }
    async function get() {
      setShowLoading(true);
      try {
        const config = {
          headers: headers(),
        };
        const { data } = await apiOperation.get<RetornoAnalise>(
          `analise/obter?analiseId=${id}`,
          config,
        );
        if (data) {
          setResult(data.valor[0] || []);
          viewDetaisIndicators(data.valor[0].analiseDemonstrativo || []);
        }
      } catch (error: any) {
        // setResult(mock.valor);
      } finally {
        setShowLoading(false);
      }
    }
    get();
  }, [id]);

  const defineColor = (progress: number | undefined): string | undefined =>
    progress
      ? (colorsProgress.find((item) => item.key <= progress) || {}).value ||
        undefined
      : undefined;

  const handleOpen = (title: string) => {
    let children =
      title === "Liquidez" ? (
        <TableLiquidity
          analiseDemonstrativo={result?.analiseDemonstrativo || []}
        />
      ) : title === "Endividamento" ? (
        <TableIndebtedness
          analiseDemonstrativo={result?.analiseDemonstrativo || []}
        />
      ) : title === "Rentabilidade" ? (
        <TableProfitability
          analiseDemonstrativo={result?.analiseDemonstrativo || []}
        />
      ) : title === "Socios" ? (
        <TablePartners listPartners={result?.analiseSociedade || []} />
      ) : title === "Documentos" ? (
        <TableDocuments listDocument={result?.analiseDocumentacao || []} />
      ) : (
        <> </>
      );
    setModalState({
      open: true,
      title,
      children,
    });
  };

  const montarEndereco = () => {
    const cliente = result?.analiseCliente?.find((x) => x)?.cliente;
    if (!cliente) return "Endereço não disponível";
    return `${cliente.endereco}, ${cliente.bairro} - ${cliente.cidade}, ${cliente.estado} - ${cliente.cep}`;
  };

  const textoRiscoCredito = () => {
    const valor = result?.analiseCredito?.find((x) => x)?.scoreCalculado || 0;
    return valor < 40 ? "Alto" : valor > 70 ? "Baixo" : "Médio";
  };

  const typePortText = () => {
    const value = result?.analisePorte?.find((x) => x)?.tipoPorte || 0;
    const index = Object.values(TipoPorte).indexOf(value);
    const port = Object.keys(TipoPorte)[index];
    return port || "N/D";
  };

  const disabledButtonDocuments = () => {
    const docs = result?.analiseDocumentacao || [];
    return docs.length > 0;
  };

  const handleMask = (value: any) => {
    if (value?.cnpjOuCpf) {
      return value.cnpjOuCpf.length > 11
        ? cnpjMask(value.cnpjOuCpf)
        : cpfMask(value.cnpjOuCpf);
    }
    return "";
  };

  const mascaraMoeda = (event: any) => {
    const onlyDigits = event.target.value
      .split("")
      .filter((s: any) => /\d/.test(s))
      .join("")
      .padStart(3, "0");
    const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2);
    event.target.value = maskCurrency(digitsFloat);
  };

  const maskCurrency = (valor: any, locale = "pt-BR", currency = "BRL") => {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(valor);
  };

  const tipoDocumentoBusca = (value: any) => {
    if (value?.cnpjOuCpf) {
      return value.cnpjOuCpf.length > 11 ? "CNPJ" : "CPF";
    }
    return "Documento";
  };

  const ehPreAnalise = result.tipoAnalise === 4;

  const numeroFuncionariosPreAnalise =
    result.analiseMetadado?.find((x) => x.tipoParametro === 115)?.valor;

  const restritivo = result.analisePorte
    ?.find((x) => x)
    ?.analiseRestritivo?.find((x) => x);

  const indicadoresRestritivos = ehPreAnalise
    ? [
        {
          label: "Protestos",
          value: restritivo?.qtdeProtesto || 0,
        },
      ]
    : [
        { label: "Pendências", value: restritivo?.pontosCalculado || 0 },
        { label: "Protestos", value: restritivo?.qtdeProtesto || 0 },
        {
          label: "Ações Judiciais",
          value: restritivo?.qtdeAcaoJudicial || 0,
        },
        {
          label: "Cheques S/ Fundo",
          value: restritivo?.qtdeChequeSemFundo || 0,
        },
        {
          label: "Rec. Jud. / Falência",
          value: restritivo?.qtdeFalenciaRecuperacaoJudicial || 0,
        },
        {
          label: "Pend. Trabalhistas",
          value: restritivo?.qtdePendenciaTrabalhista || 0,
        },
      ];

  const tipoFundacaoNascimento = (value: any) => {
    if (value?.cnpjOuCpf) {
      return value.cnpjOuCpf.length > 11
        ? "Data Fundação: "
        : "Data de Nascimento: ";
    }
    return "Data: ";
  };

  const Download = async (params = "") => {
    try {
      const config = {
        headers: headers(),
      };

      setShowLoading(true);
      let urlString = `analise/relatorio?analiseId=${params}`;

      const { data } = await apiOperation.get<Documento>(urlString, config);

      window.open(data.valor, "_blank", "noopener,noreferrer");

      setShowLoading(false);
    } catch (error: any) {
      setShowLoading(false);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
    setModalState({
      open: false,
      title: "",
      children: <></>,
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
    setErrors({
      ...errors,
      [id]: "",
    });
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    setFormData({
      ...formData,
      tipoLimite: e.target.value,
    });
    setErrors({
      ...errors,
      tipoLimite: "",
    });
  };

  const handleMoneyValue = (value: any) => {
    let money: any = 0;
    if (value) {
      money = value.replace("R$ ", "").replace(/\./g, "").replace(",", ".");
    } else {
      money = "0.0";
    }
    return money;
  };

  const atualizarLimiteSugerido = async () => {
    const newErrors: Partial<FormData> = {};
    if (!formData.codigoEmpresa)
      newErrors.codigoEmpresa = "Código da empresa é obrigatório";
    if (formData.tipoLimite === "AMBOS") {
      if (!formData.valorFaturado)
        newErrors.valorFaturado = "Valor Faturado é obrigatório";
      if (!formData.valorCartao)
        newErrors.valorCartao = "Valor Cartão é obrigatório";
    } else {
      if (!formData.valorLimite)
        newErrors.valorLimite = "Limite Sugerido é obrigatório";
    }
    if (!formData.tipoLimite)
      newErrors.tipoLimite = "Tipo de Limite é obrigatório";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoading(true);
      const config = {
        headers: headers(),
      };

      const data =
        formData.tipoLimite === "AMBOS"
          ? {
              CodigoEmpresa: formData.codigoEmpresa,
              TipoLimite: handleMoneyValue(formData.tipoLimite),
              ValorFaturado: handleMoneyValue(formData.valorFaturado),
              ValorCartao: handleMoneyValue(formData.valorCartao),
              Descricao: formData.parecerComercial,
            }
          : {
              ValorLimite: handleMoneyValue(formData.valorLimite),
              CodigoEmpresa: formData.codigoEmpresa,
              TipoLimite: formData.tipoLimite,
              Descricao: formData.parecerComercial,
            };

      await apiOperation.post("analise/alterarlimite", data, config);

      handleClose();
      setShowLoading(false);
      setFormData({
        codigoEmpresa: "",
        valorLimite: "",
        tipoLimite: "FAT",
        valorFaturado: "",
        valorCartao: "",
        parecerComercial: "",
      });
    } catch (error) {
      handleClose();
      setShowLoading(false);
      setFormData({
        codigoEmpresa: "",
        valorLimite: "",
        tipoLimite: "FAT",
        valorFaturado: "",
        valorCartao: "",
        parecerComercial: "",
      });
    }
  };

  return (
    <>
      <Header />
      <Container id="printPDF">
        {showLoading ? (
          <Loading hidden={!showLoading} />
        ) : (
          <Box
            sx={{
              p: { xs: 2, md: 4 },
              maxWidth: "1400px",
              margin: "0 auto",
              bgcolor: "var(--surface-sunken)",
              minHeight: "100vh",
            }}
          >
            {/* HEADER DA PÁGINA */}
            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", md: "center" }}
              spacing={2}
              mb={4}
            >
              <Box>
                <Typography variant="h4" fontWeight="bold" color="text.primary">
                  Resultado da Pesquisa
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {tipoDocumentoBusca(result)}: {handleMask(result)}
                </Typography>
              </Box>

              <Stack direction="row" spacing={2}>
                <Button
                  color="secondary"
                  variant="outlined"
                  startIcon={<InsertDriveFile />}
                  disabled={!disabledButtonDocuments()}
                  onClick={() => handleOpen("Documentos")}
                >
                  Documentos
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  startIcon={<InsertDriveFile />}
                  disabled={result.status?.descricao !== "Concluída"}
                  onClick={() => Download(result.analiseId)}
                >
                  Gerar Relatório
                </Button>
              </Stack>
            </Stack>

            <Grid container spacing={3}>
              {/* SEÇÃO 1: INFORMAÇÕES BÁSICAS E STATUS */}
              <Grid item xs={12} md={8}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    p: 3,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={3}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    height="100%"
                  >
                    <Box flex={1}>
                      <Typography variant="overline" color="text.secondary">
                        Cliente / Empresa
                      </Typography>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        color="text.primary"
                      >
                        {result?.analiseCliente?.find((x) => x.cliente)?.cliente
                          ?.razao || "N/D"}
                      </Typography>
                    </Box>
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ display: { xs: "none", sm: "block" } }}
                    />
                    <Box flex={1}>
                      <Typography variant="overline" color="text.secondary">
                        Status da Análise
                      </Typography>
                      <Box mt={0.5} mb={1}>
                        <Chip
                          label={result?.status?.descricao || "Desconhecido"}
                          color={
                            result?.status?.descricao === "Concluída"
                              ? "success"
                              : "warning"
                          }
                          size="small"
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        Mensagem:{" "}
                        {result?.analiseCredito?.find((x) => x)?.rating
                          ?.descricao || "N/A"}
                      </Typography>
                    </Box>
                  </Stack>
                </Card>
              </Grid>

              {/* SEÇÃO 2: SCORE DE CRÉDITO */}
              <Grid item xs={12} md={4}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    p: 3,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={3}
                    alignItems="center"
                    width="100%"
                  >
                    <ProgressCircle
                      value={
                        result?.analiseCredito?.find((x) => x)
                          ?.scoreCalculado || 0
                      }
                      size={"80px"}
                      color={defineColor(
                        result?.analiseCredito?.find((x) => x)?.scoreCalculado,
                      )}
                    >
                      <Box textAlign="center">
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          lineHeight={1}
                        >
                          {result?.analiseCredito?.find((x) => x)
                            ?.scoreCalculado || 0}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          de 100
                        </Typography>
                      </Box>
                    </ProgressCircle>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        textTransform="uppercase"
                      >
                        Risco de Crédito
                      </Typography>
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        color={
                          defineColor(
                            result?.analiseCredito?.find((x) => x)
                              ?.scoreCalculado,
                          ) || "text.primary"
                        }
                      >
                        {textoRiscoCredito()}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Rating:{" "}
                        {result?.analiseCredito?.find((x) => x)?.rating
                          ?.identificador || "N/A"}
                      </Typography>
                    </Box>
                  </Stack>
                </Card>
              </Grid>

              {/* SEÇÃO 3: LIMITE SUGERIDO */}
              <Grid item xs={12}>
                <Card
                  elevation={0}
                  sx={{
                    p: 3,
                    bgcolor: "var(--info-surface)",
                    border: "1px solid var(--border-default)",
                    borderRadius: 2,
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    spacing={2}
                  >
                    <Box>
                      <Typography
                        variant="overline"
                        color="primary.main"
                        fontWeight="bold"
                      >
                        Limite Sugerido
                      </Typography>
                      <Typography
                        variant="h3"
                        color="primary.dark"
                        fontWeight="bold"
                      >
                        R${" "}
                        {result?.analiseCredito
                          ?.find((x) => x)
                          ?.limiteCalculado?.toLocaleString("pt-br", {
                            minimumFractionDigits: 2,
                          }) || "0,00"}
                      </Typography>
                    </Box>
                    {carregaItens && (
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<RefreshIcon />}
                        onClick={() => setModalOpen(true)}
                      >
                        Atualizar Limite
                      </Button>
                    )}
                  </Stack>
                </Card>
              </Grid>

              {/* SEÇÃO 4: ALERTAS E RESTRITIVOS */}
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  mb={2}
                  color="text.primary"
                >
                  Indicadores Restritivos
                </Typography>
                <Grid container spacing={2}>
                  {indicadoresRestritivos.map((item, index) => (
                    <Grid item xs={6} sm={4} md={2} key={index}>
                      <Card
                        variant="outlined"
                        sx={{
                          p: 2,
                          textAlign: "center",
                          borderColor:
                            item.value > 0 ? "error.main" : "divider",
                          borderRadius: 2,
                        }}
                      >
                        <Typography
                          variant="h4"
                          fontWeight="bold"
                          color={item.value > 0 ? "error.main" : "text.primary"}
                        >
                          {item.value}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            textTransform: "uppercase",
                            mt: 1,
                            display: "block",
                          }}
                        >
                          {item.label}
                        </Typography>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              {/* SEÇÃO 5: DADOS ADICIONAIS & SOCIETÁRIOS */}
              <Grid item xs={12} md={7}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    p: 3,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    mb={3}
                    color="text.primary"
                  >
                    Dados Cadastrais
                  </Typography>
                  <Stack spacing={2}>
                    <Row>
                      <Text style={CellTitle}>Situação Cadastral:</Text>
                      <CellDivider />
                      <Text style={CellContent}>
                        {result?.analiseCliente?.find((x) => x)?.cliente?.ativo
                          ? "Ativa"
                          : "Inativa"}
                      </Text>
                    </Row>
                    <Row>
                      <Text style={CellTitle}>
                        {tipoFundacaoNascimento(result)}
                      </Text>
                      <CellDivider />
                      <Text style={CellContent}>
                        {moment(
                          result?.analiseCliente?.find((x) => x)?.cliente
                            ?.dataFundacao,
                        ).format("DD/MM/YYYY")}
                      </Text>
                    </Row>
                    <Row>
                      <Text style={CellTitle}>Porte:</Text>
                      <CellDivider />
                      <Text style={CellContent}>{typePortText()}</Text>
                    </Row>
                    {ehPreAnalise && tipoDocumentoBusca(result) !== "CPF" && (
                      <Row>
                        <Text style={CellTitle}>Número de Funcionários:</Text>
                        <CellDivider />
                        <Text style={CellContent}>
                          {numeroFuncionariosPreAnalise || "N/D"}
                        </Text>
                      </Row>
                    )}
                    <Row>
                      <Text style={CellTitle}>E-mail:</Text>
                      <CellDivider />
                      <Text
                        style={{
                          ...CellContent,
                          wordWrap: "break-word",
                          wordBreak: "break-word",
                        }}
                      >
                        {result?.analiseCliente?.find((x) => x)?.cliente
                          ?.email || "N/D"}
                      </Text>
                    </Row>
                    <Row>
                      <Text style={CellTitle}>Endereço:</Text>
                      <CellDivider />
                      <Text style={CellContent}>{montarEndereco()}</Text>
                    </Row>

                    {/* NOVO MAPA COM IFRAME LIVRE DE API KEY */}
                    {result?.analiseCliente?.find((x) => x)?.cliente && (
                      <Box mt={2} borderRadius={2} overflow="hidden">
                        <iframe
                          width="100%"
                          height="250"
                          style={{ border: 0, display: "block" }}
                          loading="lazy"
                          allowFullScreen={false}
                          src={`https://maps.google.com/maps?q=${encodeURIComponent(montarEndereco())}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                        />
                      </Box>
                    )}
                  </Stack>
                </Card>
              </Grid>

              <Grid item xs={12} md={5}>
                <Stack spacing={3} height="100%">
                  {/* Info Societária (Mostra apenas se não for CPF) */}
                  {tipoDocumentoBusca(result) !== "CPF" && (
                    <Card
                      elevation={0}
                      sx={{
                        p: 3,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                      }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        mb={3}
                        color="text.primary"
                      >
                        Informações Societárias
                      </Typography>
                      <Stack spacing={2}>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography variant="body1" color="text.secondary">
                            Número de Sócios:
                          </Typography>
                          <Box display="flex" alignItems="center" gap={2}>
                            <Typography variant="h6" fontWeight="bold">
                              {result.analiseSociedade?.length || 0}
                            </Typography>
                            <Button
                              size="small"
                              onClick={() => handleOpen("Socios")}
                              variant="outlined"
                            >
                              Ver Sócios
                            </Button>
                          </Box>
                        </Box>
                        <Divider />
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography variant="body1" color="text.secondary">
                            Capital Social:
                          </Typography>
                          <Typography variant="h6" fontWeight="bold">
                            R${" "}
                            {result?.analiseDemonstrativo
                              ?.find(
                                (x) =>
                                  x.tipoParametro ===
                                  TipoVariavelFinanceira.CapitalSocial,
                              )
                              ?.valor?.toLocaleString("pt-br", {
                                minimumFractionDigits: 2,
                              }) || "0,00"}
                          </Typography>
                        </Box>
                      </Stack>
                    </Card>
                  )}

                  {/* Lista Suja */}
                  <Card
                    elevation={0}
                    sx={{
                      p: 3,
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      mb={3}
                      color="text.primary"
                    >
                      Listas e Apontamentos
                    </Typography>
                    <Stack spacing={2}>
                      <Row>
                        <Text style={{ ...CellTitle, textAlign: "start" }}>
                          Problemas Contratuais:
                        </Text>
                        <Text>Não Consta</Text>
                      </Row>
                      <Row>
                        <Text style={{ ...CellTitle, textAlign: "start" }}>
                          Trabalho Escravo:
                        </Text>
                        <Text>Não Consta</Text>
                      </Row>
                    </Stack>
                  </Card>

                  {/* Mensagens */}
                  {result.analiseMensagem &&
                    result.analiseMensagem.length > 0 && (
                      <Card
                        elevation={0}
                        sx={{
                          p: 3,
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 2,
                          flexGrow: 1,
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          mb={2}
                          color="text.primary"
                        >
                          Mensagens
                        </Typography>
                        <Stack spacing={1}>
                          {result.analiseMensagem
                            ?.filter(
                              (item, index, self) =>
                                index ===
                                self.findIndex(
                                  (f) => f.mensagem === item.mensagem,
                                ),
                            )
                            .map((item, index) => (
                              <Typography
                                key={index}
                                variant="body2"
                                color="text.secondary"
                                p={1}
                                bgcolor="var(--surface-sunken)"
                                borderRadius={1}
                              >
                                • {item.mensagem}
                              </Typography>
                            ))}
                        </Stack>
                      </Card>
                    )}
                </Stack>
              </Grid>
            </Grid>

            {/* Modais de Informação (Tabelas) */}
            <Modal
              open={modalState.open}
              onClose={handleClose}
              aria-labelledby="modal-info-title"
            >
              <Box sx={style}>
                <HeaderModal>
                  <SubTitle>{modalState.title}</SubTitle>
                  <IconButton onClick={handleClose}>
                    <Close />
                  </IconButton>
                </HeaderModal>
                <Box mt={2}>{modalState.children}</Box>
              </Box>
            </Modal>

            {/* Modal de Atualizar Limite */}
            <Modal
              open={modalOpen}
              onClose={handleClose}
              aria-labelledby="modal-limite-title"
            >
              <Box sx={style}>
                <HeaderModal>
                  <SubTitle>Atualizar Limite</SubTitle>
                  <IconButton onClick={handleClose}>
                    <Close />
                  </IconButton>
                </HeaderModal>
                <Box mt={3}>
                  <Stack spacing={3}>
                    <TextField
                      id="codigoEmpresa"
                      label="Código da empresa"
                      variant="outlined"
                      fullWidth
                      value={formData.codigoEmpresa}
                      onChange={handleChange}
                      error={!!errors.codigoEmpresa}
                      helperText={errors.codigoEmpresa}
                    />
                    <FormControl
                      variant="outlined"
                      fullWidth
                      error={!!errors.tipoLimite}
                    >
                      <InputLabel id="tipoLimite-label">
                        Tipo de Limite
                      </InputLabel>
                      <Select
                        labelId="tipoLimite-label"
                        id="tipoLimite"
                        value={formData.tipoLimite}
                        onChange={handleSelectChange}
                        label="Tipo de Limite"
                      >
                        <MenuItem value="FAT">Faturado</MenuItem>
                        <MenuItem value="CRT">Cartão</MenuItem>
                        <MenuItem value="AMBOS">Ambos</MenuItem>
                      </Select>
                      {!!errors.tipoLimite && (
                        <FormHelperText>{errors.tipoLimite}</FormHelperText>
                      )}
                    </FormControl>

                    {formData.tipoLimite === "AMBOS" ? (
                      <Stack direction="row" spacing={2}>
                        <TextField
                          id="valorFaturado"
                          label="Valor Faturado"
                          variant="outlined"
                          fullWidth
                          value={formData.valorFaturado}
                          onChange={handleChange}
                          onInput={mascaraMoeda}
                          error={!!errors.valorFaturado}
                          helperText={errors.valorFaturado}
                        />
                        <TextField
                          id="valorCartao"
                          label="Valor Cartão"
                          variant="outlined"
                          fullWidth
                          value={formData.valorCartao}
                          onChange={handleChange}
                          onInput={mascaraMoeda}
                          error={!!errors.valorCartao}
                          helperText={errors.valorCartao}
                        />
                      </Stack>
                    ) : (
                      <TextField
                        id="valorLimite"
                        label="Limite Sugerido"
                        variant="outlined"
                        fullWidth
                        value={formData.valorLimite}
                        onChange={handleChange}
                        onInput={mascaraMoeda}
                        error={!!errors.valorLimite}
                        helperText={errors.valorLimite}
                      />
                    )}
                    <ContainerTextArea>
                      <InputLabel sx={{ mb: 1 }}>Parecer Comercial</InputLabel>
                      <TextareaAutosize
                        minRows={5}
                        id="parecerComercial"
                        name="parecerComercial"
                        placeholder="Descrição"
                        value={formData.parecerComercial}
                        style={{
                          width: "100%",
                          padding: "10px",
                          borderRadius: "4px",
                          borderColor: "var(--border-default)",
                          fontFamily: "inherit",
                        }}
                        onChange={handleChange}
                      />
                    </ContainerTextArea>
                    <Box display="flex" justifyContent="flex-end">
                      <Button
                        color="secondary"
                        variant="contained"
                        startIcon={<SendIcon />}
                        onClick={atualizarLimiteSugerido}
                        size="large"
                      >
                        Enviar
                      </Button>
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </Modal>
          </Box>
        )}
      </Container>
    </>
  );
};
